import React from 'react';
import {BreadCrumbs} from '../components/common/bread-crumbs/BreadCrumbs';
import {Header} from '../components/g2/header/Header';
import {Banner} from '../components/common/banner/Banner';
import {SEOText} from '../components/g2/seo-text/SEOText';
import {LinkPile} from '../components/g2/link-pile/LinkPile';
import {PopularDestinations} from '../components/g2/popular-destinations/PopularDestinations';
import {PropertyTypes} from '../components/g2/property-types/PropertyTypes';
import {GreatPlacesToStay} from '../components/g2/great-places-to-stay/GreatPlacesToStay';
import {DestinationUrgency} from '../components/common/destination-urgency/DestinationUrgency';
import {DestinationInfographic} from '../components/common/destination-infographic/DestinationInfographic';
import {withErrorBoundary} from '../components/common/error-boundary/ErrorBoundary';
import {MmgLinks} from '../components/common/mmg-links/MmgLinks';
import {AsyncSiteHeader} from '../components/common/site-header/AsyncSiteHeader';
import {AsyncSiteFooter} from '../components/common/site-footer/AsyncSiteFooter';

export const Template = () => (
    <React.Fragment>
        {withErrorBoundary(<AsyncSiteHeader isInverse />)}
        <Header />
        <main className="app-main">
            <BreadCrumbs />
            <DestinationUrgency />
            <PopularDestinations />
            <PropertyTypes />
            <GreatPlacesToStay />
            {withErrorBoundary(<DestinationInfographic />)}
            <div className="container banner-container">
                <Banner />
            </div>
            <SEOText />
            <LinkPile />
        </main>
        <MmgLinks />
        {withErrorBoundary(<AsyncSiteFooter />)}
    </React.Fragment>
);
